var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/profile-2user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 2.49994C6.38 2.49994 4.25 4.62994 4.25 7.24994C4.25 9.81994 6.26 11.8999 8.88 11.9899C8.96 11.9799 9.04 11.9799 9.1 11.9899C9.12 11.9899 9.13 11.9899 9.15 11.9899C9.16 11.9899 9.16 11.9899 9.17 11.9899C11.73 11.8999 13.74 9.81994 13.75 7.24994C13.75 4.62994 11.62 2.49994 9 2.49994Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.08 14.6499C11.29 12.7899 6.73996 12.7899 3.92996 14.6499C2.65996 15.4999 1.95996 16.6499 1.95996 17.8799C1.95996 19.1099 2.65996 20.2499 3.91996 21.0899C5.31996 22.0299 7.15996 22.4999 8.99996 22.4999C10.84 22.4999 12.68 22.0299 14.08 21.0899C15.34 20.2399 16.04 19.0999 16.04 17.8599C16.03 16.6299 15.34 15.4899 14.08 14.6499Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.9904 7.83994C20.1504 9.77994 18.7704 11.4799 16.8604 11.7099C16.8504 11.7099 16.8504 11.7099 16.8404 11.7099H16.8104C16.7504 11.7099 16.6904 11.7099 16.6404 11.7299C15.6704 11.7799 14.7804 11.4699 14.1104 10.8999C15.1404 9.97994 15.7304 8.59994 15.6104 7.09994C15.5404 6.28994 15.2604 5.54994 14.8404 4.91994C15.2204 4.72994 15.6604 4.60994 16.1104 4.56994C18.0704 4.39994 19.8204 5.85994 19.9904 7.83994Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.9902 17.0899C21.9102 18.0599 21.2902 18.8999 20.2502 19.4699C19.2502 20.0199 17.9902 20.2799 16.7402 20.2499C17.4602 19.5999 17.8802 18.7899 17.9602 17.9299C18.0602 16.6899 17.4702 15.4999 16.2902 14.5499C15.6202 14.0199 14.8402 13.5999 13.9902 13.2899C16.2002 12.6499 18.9802 13.0799 20.6902 14.4599C21.6102 15.1999 22.0802 16.1299 21.9902 17.0899Z",
    fill: "#FCFCFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.470ccc4d6a96bc5a71d91df4a180f918.svg";
export { ForwardRef as ReactComponent };